module.exports = __webpack_public_path__ + "static/media/loader-logo.f86d5118.svg";